module.exports = __webpack_public_path__ + "img/pana-welcome.290285ad.svg";